import React, { useRef, useCallback } from "react";
import useFetchRiderAssignmentById from "../Libs/useFetchRiderAssignmentById";
import Spinner from "../../utils/spinner";
import { Link } from "react-router-dom";
import { FaMotorcycle } from "react-icons/fa6";
import { TfiPackage } from "react-icons/tfi";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { BsTelephone } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import "./Rider_assignment.css";

const Rideraccepted = () => {
  const {
    data,
    isLoading,
    isError,
    error,
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage,
  } = useFetchRiderAssignmentById();

  const observerRef = useRef();
  const lastRiderAssignmentElementRef = useCallback(
    (node) => {
      if (isFetchingNextPage) return;
      if (observerRef.current) observerRef.current.disconnect();

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasNextPage) {
          fetchNextPage();
        }
      });

      if (node) observerRef.current.observe(node);
    },
    [isFetchingNextPage, fetchNextPage, hasNextPage]
  );

  const filteredAssignments = Array.isArray(data?.pages)
    ? data.pages.flatMap((page) =>
        Array.isArray(page?.riderAssignments)
          ? page.riderAssignments.filter(
              (assignment) =>
                Array.isArray(assignment.accept) && assignment.accept.length > 0
            )
          : []
      )
    : [];

  return (
    <div className="assignment-link">
      {isLoading && <Spinner />}
      {isError && (
        <p style={{ fontFamily: "Montserrat" }}>Error: {error.message}</p>
      )}

      <div className="card">
        {!isLoading && !isError && (
          <>
            {filteredAssignments.length === 0 ? (
              <div className="empty-state">
                <p style={{ fontFamily: "Montserrat" }}>
                  No matching assignments found.
                </p>
                <FaMotorcycle className="empty-icon" />
              </div>
            ) : (
              filteredAssignments.map((assignment, index) => {
                const isLast = index === filteredAssignments.length - 1;
                const receiver = assignment.package?.[0]?.receiver;
                const items = assignment.package?.[0]?.items;

                return (
                  <div
                    key={assignment._id}
                    className="assignment-card"
                    ref={isLast ? lastRiderAssignmentElementRef : null}
                  >
                    <div className="assignment-card-header">
                      <div className="package-icon-wrapper">
                        <TfiPackage className="package-icon" />
                      </div>
                      <div className="assignment-id">
                        ID: {assignment._id.slice(0, 8).toUpperCase()}
                      </div>
                    </div>

                    <div className="assignment-card-body">
                      <div className="receiver-info">
                        <h2 className="receiver-name">
                          {receiver?.name || "N/A"}
                        </h2>
                      </div>

                      <div className="items-section">
                        <div className="items-label">Items:</div>
                        <div className="items-list">
                          {Array.isArray(items) && items.length > 0
                            ? items.map((item) => (
                                <span key={item?._id} className="item-tag">
                                  {item?.name} ({item?.quantity})
                                </span>
                              ))
                            : "N/A"}
                        </div>
                      </div>

                      <div className="info-row">
                        <HiOutlineLocationMarker className="info-icon" />
                        <span className="info-text">
                          {receiver?.state || "Unknown"},{" "}
                          {receiver?.address_1 || "Unknown Address"}
                        </span>
                      </div>

                      <div className="info-row">
                        <BsTelephone className="info-icon" />
                        <span className="info-text">
                          {receiver?.phone_number || "N/A"}
                        </span>
                      </div>

                      <div className="secret-pin-section">
                        <span className="secret-pin-label">Secret Pin:</span>
                        <span className="secret-pin-value">
                          {assignment?.package?.[0]?.secretPin || "N/A"}
                        </span>
                      </div>
                    </div>

                    <div className="assignment-card-footer">
                      <Link
                        to={`/details/${assignment._id}`}
                        className="view-details-btn"
                      >
                        <AiOutlineEye className="view-icon" />
                        View Details
                      </Link>
                    </div>
                  </div>
                );
              })
            )}
          </>
        )}
      </div>

      {isFetchingNextPage && <Spinner />}
    </div>
  );
};

export default Rideraccepted;
